<div
  id="supportChatSidenav"
  class="sidenav shadow"
  [ngClass]="visible ? 'support-show' : 'support-hide'"
  data-testid="support-chat-popup"
>
  <div class="support-chat-popup__inner" *ngIf="hasBeenOpened">
    <app-agent-chat
      [showClose]="true"
      [showExpand]="true"
      (close)="onVisibleChange(false)"
    ></app-agent-chat>
  </div>
</div>
